import React, { useState, useEffect } from "react";
import { useAppDispatch, useAppSelector } from "@/services/hooks";
// GET all sites
import { getSites } from "@/services/siteServices/siteActions";
import { Link } from "react-router";
// Actions 
import {
	patchProperty,
  getAllProperties
} from '@/services/productServices/productActions';


import NotificationAlertOptions from "@/layouts/Alerts";

// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  Container,
  Row,
  Col,
  // Label,
  FormGroup,
  InputGroup,
  InputGroupText,
  Form,
  Input,
} from "reactstrap";
import classnames from "classnames";
import { changeLinkedValue } from "../../Product/changeLinkedValue";

type LabelProps = {
  propTpUpdate?: { _id?: unknown } | null;
};

export const Label = (props: LabelProps) => {
  const dispatch = useAppDispatch();
  const sites = useAppSelector((state) => state.sites.sites);
  const currentSite = useAppSelector((state) => state.sites.site);
  const [propToLink, setPropToLink] = useState<any>({}); // any: an entry of products.properties, typed any there (productSlice.ts:51)
  const allProperties = useAppSelector((state)=> (state.products.properties as any))

  useEffect(() => {
    if (sites.length === 0) {
      dispatch(getSites());
    }
    dispatch(getAllProperties())
    if (props.propTpUpdate) {
      setPropToLink(allProperties.filter(prop => prop._id === props.propTpUpdate?._id)[0]);
    }
  }, [sites.length, props.propTpUpdate]);

  const onLink = (e) => {
    // SCRUM-1954: propToLink is an element of state.products.properties, which
    // the products slice stores frozen; work on a copy of it and its label list.
    let labeltState = { ...propToLink, label: [...(propToLink.label || [])] };
    e.preventDefault();

    let data: { siteid?: unknown; value?: { label: string } } = {};
    data.siteid = currentSite._id;
    data.value = { label: "" };
    // Check if the label array contains the current website id => the property is already linked to this website
    if (
      labeltState.label.filter(
        (linkedSite) => linkedSite.siteid === currentSite._id
      ).length === 0
    ) {
      labeltState.label.push(data);
      setPropToLink({
        ...labeltState,
        // __v: labeltState.__v+1
      });
      // Dispatch call to the DB
      // this.props.patchProduct(productState)
    }
    // To remove the link => the property is already linked to the current website
      else{
        setPropToLink(
          {
            ...labeltState,
            // __v: labeltState.__v+1,
            label: labeltState.label.filter(
                linkedSite =>  linkedSite.siteid !== currentSite._id
              )
          }
        )
        saveAndConfirm({...labeltState, label: labeltState.label.filter(
          linkedSite =>  linkedSite.siteid !== currentSite._id
        ) })

      }
  };

  // Method that will allow us handle the label input change 
  const changeParams = (e, siteID) => {
    setPropToLink({
      ...propToLink,
      label: changeLinkedValue(propToLink.label, siteID, e.target.name, e.target.value),
    });
  };

// Dispatch call to the DB
const updateLabelSites = () => {
  //  props.applyChanges(Product)
  let labeltState = propToLink
  // prodState.__v = Product.__v + 1
  // setProduct(prodState)
  saveAndConfirm(labeltState)

}

// Confirm only what the server stored (SCRUM-1803): patchProperty resolves
// false on a refusal, whose message the global notification hub already shows.
const saveAndConfirm = async (property) => {
  const stored = await dispatch(patchProperty(property));
  if (stored) notify("success");
};

const notify = (type) => {
  NotificationAlertOptions(type, "Label Updated Successfully");
};

  if (propToLink.label && propToLink.label.length > 0 && sites.length > 0) {
    return (
      <>
        {propToLink.label.filter(
          (linkedSite) => linkedSite.siteid === currentSite._id
        ).length === 0 ? (
          <Button
            className="my-0"
            color="btn btn-outline-success"
            onClick={onLink}
            //   style={{right: 6, top: 7, position: "absolute"}}
          >
            Add Label for current Website
          </Button>
        ) : (
          <Button
            className="my-0"
            color="btn btn-outline-danger"

              onClick= {onLink}
            //   style={{right: 5, top: 7, position: "absolute"}}
          >
            remove label from current website
          </Button>
        )}

        <div style={{ marginTop: "25px" }}>

        <Row>
            <Col>
            {[...propToLink.label].sort((a,b) => (a.siteid > b.siteid) ? 1 : ((b.siteid > a.siteid) ? -1 : 0)).map(
                (linkedSite) => {
                    // SCRUM-1401: a stored entry can name a site `getSites()` does not
                    // return — a soft-deleted one, for instance. `filter(...)[0]` is then
                    // `undefined`, and reading `.domain` off it threw and blanked the whole
                    // screen, making every record carrying such an entry unreachable.
                    //
                    // The entry is RENDERED, not skipped. It belongs to another tenant and
                    // `updateLabelSites` writes back exactly what is in state, so dropping
                    // it here would delete it on the next Update — the same silent-loss
                    // shape SCRUM-1357 and SCRUM-1359 already cost this repo twice.
                    const linkedSiteDoc = sites.find((site) => site._id === linkedSite.siteid)
                    return(
                        <div key={linkedSite.siteid}>


                        <Card>
                        <CardHeader>
                          <h4>{linkedSiteDoc ? linkedSiteDoc.domain : `Unknown site (${linkedSite.siteid})`}</h4>
                        </CardHeader>
                        <CardBody>

                            {/* Label */}
                            
                      <FormGroup className="row">
                        {/* This is the component itself, not reactstrap's Label (that import is
                            commented out above): a pre-existing nested render, kept as is
                            because this conversion changes no behaviour. */}
                        {/* @ts-expect-error -- self-reference, see above */}
                        <Label className="form-control-label" htmlFor="example-text-input" md="1">
                          Label
                        </Label>
                        <Col md="9">
                          <InputGroup className={classnames("input-group-merge")}>
                            
                              <InputGroupText>
                                <i className="ni ni-box-2" />
                              </InputGroupText>
                            <Input
                              placeholder="Insert Property Label"
                              name="label"
                              type="text"
                            defaultValue={linkedSite.value.label}
                              onChange= {(e)=>changeParams(e, linkedSite.siteid)}
                            //   invalid={!this.state.validation.title}
                            />
                          </InputGroup>
                          </Col>
                      </FormGroup>
                         
                        </CardBody>
                      </Card>
                      </div>
                    )
                   
                }

            )}
            <FormGroup className="row">
                        <Col md="12" className=" text-right">
                        {/* <Button
                              className="my-0"
                              color="btn btn-outline-default"
                              to="/admin/globalproducts"
                              tag={Link}
                            >
                              Back To Products
                            </Button> */}
                        <Button
                              className="my-4"
                              color="btn btn-outline-primary"
                              type="submit"
                            onClick={updateLabelSites}
                            >
                              Update
                            </Button>
                        </Col>
                      </FormGroup>
            </Col>
          
        </Row>


        </div>



        
      </>
    );
  } else if (propToLink.label && propToLink.label.length === 0) {
    return (
      <>
        {propToLink.label.filter(
          (linkedSite) => linkedSite.siteid === currentSite._id
        ).length === 0 ? (
          <Button
            className="my-0"
            color="btn btn-outline-success"
            onClick={onLink}
          >
            Add Label for current Website
          </Button>
        ) : (
          <Button
            className="my-0"
            color="btn btn-outline-danger"

              onClick= {onLink}
          >
            remove label from current website
          </Button>
        )}
        <div style={{ marginTop: "25px" }}>
          Property does not have any Label in any website
        </div>
      </>
    );
  } else {
    return <></>;
  }
};

